/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

export default class PrivacyPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <section className="container mx-auto px-4 md:px-12 py-16 lg:py-24">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-theme-blue font-bold leading-tight mb-8">
              Privacy Policies
            </h1>
            <div className="text-lg text-gray-500 font-light leading-relaxed space-y-6">
              <p>
                At Drava Studio, accessible from our website, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Drava Studio and how we use it.
              </p>
              
              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">1. Information Collection</h2>
              <p>
                The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
              </p>

              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">2. How We Use Your Information</h2>
              <p>
                We use the information we collect in various ways, including to: Provide, operate, and maintain our website. Improve, personalize, and expand our website. Understand and analyze how you use our website. Develop new products, services, features, and functionality. Communicate with you, either directly or through one of our partners.
              </p>

              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">3. Log Files</h2>
              <p>
                Drava Studio follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks.
              </p>

              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">4. Third Party Privacy Policies</h2>
              <p>
                Drava Studio's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
              </p>
              
              <p className="mt-8 text-sm">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}
